import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const ComputerMsgIconSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };
  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 19.15H6.5C3.16 19.15 1.25 17.24 1.25 13.9V8.5C1.25 5.16 3.16 3.25 6.5 3.25H9.2C9.44 3.25 9.67 3.37006 9.81 3.56006C9.95 3.75006 9.99 4.00999 9.91 4.23999C9.8 4.54999 9.75 4.89 9.75 5.25V9.15002C9.75 9.91002 9.98 10.54 10.42 10.98C10.86 11.42 11.49 11.65 12.25 11.65C12.66 11.65 13 11.99 13 12.4V13.6L15.73 11.77C15.85 11.69 16 11.64 16.15 11.64H18.75C19.11 11.64 19.45 11.59 19.76 11.48C19.99 11.4 20.24 11.44 20.44 11.58C20.64 11.72 20.75 11.9499 20.75 12.1899V13.89C20.75 17.24 18.84 19.15 15.5 19.15ZM6.5 4.75C3.98 4.75 2.75 5.98 2.75 8.5V13.9C2.75 16.42 3.98 17.65 6.5 17.65H15.5C18.02 17.65 19.25 16.42 19.25 13.9V13.12C19.09 13.14 18.92 13.15 18.75 13.15H16.38L13.68 14.95C13.24 15.23 12.69 15.26 12.24 15.01C11.79 14.77 11.51 14.3 11.51 13.79V13.09C10.67 12.96 9.93 12.59 9.37 12.04C8.66 11.33 8.26 10.3 8.26 9.15002V5.25C8.26 5.08 8.27 4.91 8.28 4.75H6.5Z"
        fill="currentColor"
      />
      <path
        d="M12.9 15.1801C12.67 15.1801 12.44 15.12 12.23 15.01C11.78 14.77 11.5 14.3 11.5 13.79V13.09C10.66 12.96 9.92 12.59 9.36 12.04C8.65 11.33 8.25 10.3 8.25 9.15002V5.25C8.25 4.72 8.33 4.22001 8.49 3.76001C9.05 2.19001 10.45 1.25 12.25 1.25H18.75C21.1 1.25 22.75 2.89 22.75 5.25V9.15002C22.75 10.95 21.82 12.35 20.25 12.91C19.77 13.07 19.27 13.15 18.75 13.15H16.38L13.68 14.95C13.44 15.11 13.17 15.1801 12.9 15.1801ZM12.25 2.75C11.1 2.75 10.25 3.3 9.91 4.25C9.81 4.55 9.75 4.89 9.75 5.25V9.15002C9.75 9.91002 9.98 10.54 10.42 10.98C10.86 11.42 11.49 11.65 12.25 11.65C12.66 11.65 13 11.99 13 12.4V13.6L15.73 11.77C15.85 11.69 16 11.64 16.15 11.64H18.75C19.11 11.64 19.45 11.59 19.76 11.48C20.71 11.14 21.25 10.29 21.25 9.14001V5.23999C21.25 3.69999 20.29 2.73999 18.75 2.73999H12.25V2.75Z"
        fill="currentColor"
      />
      <path
        d="M14.5999 22.75H7.3999C6.9899 22.75 6.6499 22.41 6.6499 22C6.6499 21.59 6.9899 21.25 7.3999 21.25H14.5999C15.0099 21.25 15.3499 21.59 15.3499 22C15.3499 22.41 15.0099 22.75 14.5999 22.75Z"
        fill="currentColor"
      />
      <path
        d="M11 22.75C10.59 22.75 10.25 22.41 10.25 22V18.4C10.25 17.99 10.59 17.65 11 17.65C11.41 17.65 11.75 17.99 11.75 18.4V22C11.75 22.41 11.41 22.75 11 22.75Z"
        fill="currentColor"
      />
      <path
        d="M15.4399 8C15.0199 8 14.6899 7.66 14.6899 7.25C14.6899 6.84 15.0299 6.5 15.4399 6.5C15.8499 6.5 16.1899 6.84 16.1899 7.25C16.1899 7.66 15.8499 8 15.4399 8Z"
        fill="currentColor"
      />
      <path
        d="M18.25 8C17.83 8 17.5 7.66 17.5 7.25C17.5 6.84 17.84 6.5 18.25 6.5C18.66 6.5 19 6.84 19 7.25C19 7.66 18.66 8 18.25 8Z"
        fill="currentColor"
      />
      <path
        d="M12.6201 8C12.2001 8 11.8701 7.66 11.8701 7.25C11.8701 6.84 12.2101 6.5 12.6201 6.5C13.0301 6.5 13.3701 6.84 13.3701 7.25C13.3701 7.66 13.0401 8 12.6201 8Z"
        fill="currentColor"
      />
    </svg>
  );
};
const ComputerMsgIcon = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={ComputerMsgIconSVG}
      style={{
        // color: color || themeDefault?.info?.newConfig?.color,

        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default ComputerMsgIcon;
